import React, { Component } from 'react';

import './header.scss';

import * as img from '../../lib/images';
import * as env from '../../lib/environment';

import MyButton from '../button'

const headerSection = (props) => {
    if (props.isMobile) {
        return (
            <div className="d-flex headerSection align-items-center ">
                <div className="col-12 p-0 h-100 d-flex justify-content-center flex-column">
                    <div className="w-100 justify-content-center d-flex">
                        <p className="m-0" style={{ color: "#212529", lineHeight: "1" }} className="headerTitle" >THE ERA OF <span style={{ color: env.BASE_COLOR }}>CODE</span></p>
                    </div>

                    <div style={{ padding: "0rem 0rem", textAlign: "center" }} className="w-100 justify-content-center d-flex">
                        <p className="m-0" style={{ fontSize: "1.1rem" }}>The first Indian company developing an integrated solution for the global self storage industry.</p>
                    </div>
                    <div data-aos="fade-up" className="w-100 justify-content-center d-flex py-2">
                        <img style={{ zIndex: 10 }} className="headerLogo" src={img.HEADER_IMAGE} />
                    </div>
                    <div className="w-100 justify-content-center d-flex py-2">
                        <MyButton value="View Open Positionsss" />
                    </div>


                </div>
                {/* <div className="col-6 d-flex justify-content-end px-0 py-3 h-100 "  >
                   
                </div> */}

            </div>
        )
    }
    else {
        return (
            <div className="d-flex headerSection align-items-center rightBackImage">
                <div className="col-6 p-0 h-100 d-flex justify-content-center flex-column">
                    <div>
                        <p className="m-0" style={{ color: "#212529", lineHeight: "1.5" }} className="headerTitle" >THE ERA OF <span style={{ color: env.BASE_COLOR }}>CODE</span></p>
                    </div>
                    <div style={{ padding: "2.5rem 0rem" }}>
                        <p className="m-0" style={{ fontSize: "1.1rem" }}>The first Indian company developing an integrated solution for the global self storage industry.</p>
                    </div>
                    <MyButton value="View Open Positionsss" />
                </div>
                <div data-aos="fade-up" className="col-6 d-flex justify-content-end px-0 py-3 h-100 " >
                    <img style={{ zIndex: 10 }} className="headerLogo" src={img.HEADER_IMAGE} />
                </div>

            </div>
        )
    }

}
export default headerSection;